module.exports = __webpack_public_path__ + "img/turrets.03b3d6c9.png";